import React from 'react';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { SelectFieldTW } from '../../../../../tailwindComponents/selectTW/SelectFieldTW';
import { SmallBodyText } from '../../../../../ui-toolkit';
import { DisplayServices } from '../../../../../ui-toolkit/enums/eServices';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { optionsFromDisplay } from '../../../../../ui-toolkit/enums/optionsFromDisplay';

export const Services: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={`Services`}
      tab={`summary`}
      field={`services`}
      onUpdate={(_, value) => onPatchOrderInformation({ services: value })}
      order={order}
      editControl={SelectFieldTW}
      editProps={{ options: optionsFromDisplay(DisplayServices), isMultiple: true, className: 'h-10 text-left' }}
    >
      {order.transaction.services?.length ? (
        order.transaction.services.map((s) => DisplayServices[s]).join(', ')
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
